import Vue from 'vue'
import router from '../router'

const state = {
  accessToken: localStorage.getItem('accessToken') || '',
  rememberMe: JSON.parse(localStorage.getItem('rememberMe')) || false,
  authErrors: null,
  firstLogin: localStorage.getItem('firstLogin') || '',
  userType: localStorage.getItem('userType') || '',
  userPackage: localStorage.getItem('userPackage') || '',
}

const getters = {
  isAuthenticated: state => !!state.accessToken,
  accessToken: state => state.accessToken,
  rememberMe: state => state.rememberMe,
  authErrors: state => state.authErrors,
  authMessage: state => state.authMessage,
  firstLogin: state => state.firstLogin,
  userType: state => state.userType,
  userPackage: state => state.userPackage
}

const actions = {
  isLoggedIn ({ dispatch, commit, state }, payload) {
  // eslint-disable-next-line no-undef
  if (!payload.visitorId && state.accessToken) { return Promise.resolve() }
  return $client.post(`auth/isLoggedIn`, payload)
    .then(({ status, data }) => {
      commit('setAuthErrors', null)
      if (status) {
        if(data){
          const response = data.data
          if(response.message){
            commit('setAuthMessage', response.message)
          } else {
            dispatch('firstLogin', response.first_login)
            dispatch('userType', response.type)
            dispatch('userPackage', response.package)
            dispatch('setToken', response.token)
          }
          return data
        } else {
          if(state.accessToken && payload && payload.visitorId){
            dispatch('removeToken')
            dispatch('rememberMe', false)
            localStorage.removeItem('me')
            delete $client.defaults.headers.common.Authorization
            router.push('/login')
          }
        }
      }
    }).catch(error => {
      commit('setAuthErrors', error.data.message)
      dispatch('removeToken')
      return error.data
    })
  },
  auth ({ dispatch, commit }, payload) {
  // eslint-disable-next-line no-undef
  return $client.post(`auth/${payload.url}`, payload.fields)
    .then(({ status, data: { data } }) => {
      commit('setAuthErrors', null)
      if (status) {
        if(data.message){
          commit('setAuthMessage', data.message)
        } else {
          localStorage.setItem('domain', '.itender.am');
          dispatch('rememberMe', payload.rememberMe)
          dispatch('firstLogin', data.first_login)
          dispatch('userType', data.type)
          dispatch('userPackage', data.package)
          dispatch('setToken', data.token)
        }
        return data
      }
    }).catch(error => {
      // API errors thrown via AppException come back nested as { error: { message, code } };
      // validation errors stay flat as { message, errors }.
      const errorPayload = (error.data && error.data.error) ? error.data.error : error.data
      commit('setAuthErrors', errorPayload ? errorPayload.message : null)
      dispatch('removeToken')
      return errorPayload
    })
  },
  logout ({ dispatch }, payload) {
    return new Promise((resolve) => {
      $client.post(`auth/logout`, payload).then((value) => {
        dispatch('removeToken')
        dispatch('rememberMe', false)
        localStorage.removeItem('me')
        delete $client.defaults.headers.common.Authorization
        // router.push('/')
        const url = process.env.VUE_APP_LANDING_URL + '/';
        window.location = url;
      })
      resolve()
    })
  },
  rememberMe ({ commit }, shouldRememberMe) {
    commit('setRememberMe', shouldRememberMe)
    localStorage.setItem('rememberMe', shouldRememberMe)
  },
  setToken ({ commit }, accessToken) {
    commit('setAccessToken', accessToken)
    localStorage.setItem('accessToken', accessToken)
  },
  firstLogin ({ commit }, firstLogin) {
    commit('setFirstLogin', firstLogin)
    localStorage.setItem('firstLogin', firstLogin)
  },
  userType ({ commit }, userType) {
    commit('setUserType', userType)
    localStorage.setItem('userType', userType)
  },
  userPackage ({ commit }, userPackage) {
    commit('setUserPackage', userPackage)
    localStorage.setItem('userPackage', userPackage)
  },
  removeToken ({ commit }) {
    commit('setAccessToken', '')
    localStorage.removeItem('accessToken')
  },
  removeAuthErrors ({ commit }) {
    console.log('a')
    commit('setAuthErrors', '')
  }
}

const mutations = {
  setAccessToken (state, accessToken) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'accessToken', _.clone(accessToken))
  },
  setFirstLogin (state, firstLogin) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'firstLogin', _.clone(firstLogin))
  },
  setUserType (state, userType) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'userType', _.clone(userType))
  },
  setUserPackage (state, userPackage) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'userPackage', _.clone(userPackage))
  },
  setRememberMe (state, shouldRememberMe) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'rememberMe', _.clone(shouldRememberMe))
  },
  setAuthErrors (state, errors) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'authErrors', _.clone(errors))
  },
  setAuthMessage (state, errors) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'authMessage', _.clone(errors))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
